/* global document */

// Manage focus method detection

import $ from "jquery";

$(() => {
  // Define closure-specific variables
  /** Stores the last potential focus method the user used */
  let lastFocusMethod;
  /** Stores the last focus target. Cleared on blur */
  let lastTarget;

  // Detect input methods and store them in `lastFocusMethod`

  // NOTE: this event notation tells jQuery to bind the event to all children
  // of `document` dynamically (i.e. even if they were generated after the DOM
  // onload event)
  $(document).on("keydown", "*", () => {
    lastFocusMethod = "key";
  });

  $(document).on("mousedown", "*", () => {
    lastFocusMethod = "mouse";
  });

  $(document).on("touchstart", "*", () => {
    lastFocusMethod = "touch";
  });

  // Handle focus event
  $(document).on("focus", "*", (ev) => {
    if (lastTarget) {
      lastTarget.removeAttribute("data-focus-method");
    }
    lastTarget = ev.target;
    ev.target.setAttribute("data-focus-method", lastFocusMethod);
  });

  $(document).on("blur", "*", () => {
    if (lastTarget) {
      lastTarget.removeAttribute("data-focus-method");
    }
    lastTarget = null;
  });

  $(document).on("keyup", "div[role=button], div[role=switch]", e => {
    if (e.which === 13) {
      // Trigger fake click
      $(e.target).click();
    }
  })
});



// WEBPACK FOOTER //
// ./src/frontend/common/page/focus.js